import React from "react";
import { inject } from "mobx-react";

import Input from "../../blocks/Input";

@inject('modal')
export default class CreateAtendee extends React.Component {
  state = {
    id: 0,
    first_name: "",
    last_name: "",
    email: "",
    errorText: ""
  };

  componentDidMount() {
    console.log('saddadasd')
    if(this.props.modal.assignedTo) {
      this.setState({
        ...this.props.modal.assignedTo
      })
    }

  }
  componentWillUnmount() {
    this.props.modal.setAssignedTo({})
  }
  handleSubmit = () => {
    this.props.modal.submitFunction(this.state)
  };

  handleChange = data => {
    let newState = Object.assign(this.state, data);
    this.setState(newState);
  };

  render() {
    return (
      <div className="modal-window-wrapper">
        <div className="inner-modal-window">
          <div className="close-btn" onClick={() => this.props.modal.toggleModal()}>
            <div className="close-btn-wrapper">
              <span />
              <span />
            </div>
          </div>
          <p className="mw-title">{this.state.id > 0 ? 'Edit Attendee' : 'New Attendee'}</p>
          <div className="inputs-wrapper">
            <div>
              <div className="row">
                <div className="col">
                  <Input
                    name="first_name"
                    type="text"
                    value={this.state.first_name}
                    handleChange={this.handleChange}
                    placeholder="First Name"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Input
                    name="last_name"
                    type="text"
                    value={this.state.last_name}
                    handleChange={this.handleChange}
                    placeholder="Last Name"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Input
                    name="email"
                    type="email"
                    value={this.state.email}
                    handleChange={this.handleChange}
                    placeholder="Email Address"
                    error={this.state.errorText}
                  />
                </div>
              </div>
              <div className="buttons-row">
                <button type="submit" className="btn-submit" onClick={() => this.handleSubmit()}>
                  Save
                </button>
                <button className="btn-cancel" onClick={() => this.props.modal.toggleModal()}>cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateAtendee.jsx